export default __webpack_public_path__ + "static/media/28-min.2d0d8a7c.jpg";